import { store } from "../redux/store";
import { gatewayPhone } from "./gatewayPhone";

const resolveCompanyId = (companyIdOverride?: string | number | null): string | null => {
  if (companyIdOverride != null && companyIdOverride !== "") {
    return String(companyIdOverride);
  }

  const state = store.getState().userState;

  return (
    (state.company?.id != null ? String(state.company.id) : null) ??
    (state.activeCompanyId != null ? String(state.activeCompanyId) : null) ??
    localStorage.getItem("activeCompanyId")
  );
};

/**
 * Clears WebRTC and Twilio presence in vr-assistant before local credentials are wiped.
 * Must run while the auth token is still available in localStorage.
 */
export const disconnectPresenceSessions = async (
  companyIdOverride?: string | number | null,
): Promise<void> => {
  const token = localStorage.getItem("token");
  const companyId = resolveCompanyId(companyIdOverride);

  if (!companyId || !token) {
    return;
  }

  const numericCompanyId = Number(companyId);
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    "x-company-id": companyId,
  };

  await Promise.all([
    gatewayPhone
      .post("/webrtc/session/disconnect", { companyId: numericCompanyId }, { headers })
      .catch(() => undefined),
    gatewayPhone.post("/twilio/disconnect", {}, { headers }).catch(() => undefined),
  ]);
};
